export const TakaraMarketStateAbi = [
  {
    inputs: [],
    name: 'getActiveMarketsInfo',
    outputs: [
      {
        components: [
          { internalType: 'uint256', name: 'tvl', type: 'uint256' },
          { internalType: 'uint256', name: 'ltv', type: 'uint256' },
          {
            internalType: 'uint256',
            name: 'exchangeRateCurrent',
            type: 'uint256',
          },
          {
            internalType: 'uint256',
            name: 'reserveFactorMantissa',
            type: 'uint256',
          },
          { internalType: 'uint256', name: 'totalSupply', type: 'uint256' },
          { internalType: 'bool', name: 'isListed', type: 'bool' },
          { internalType: 'uint256', name: 'totalBorrows', type: 'uint256' },
          {
            internalType: 'uint256',
            name: 'supplyRatePerBlock',
            type: 'uint256',
          },
          {
            internalType: 'uint256',
            name: 'borrowRatePerBlock',
            type: 'uint256',
          },
          {
            internalType: 'uint256',
            name: 'blocksPerYear',
            type: 'uint256',
          },
          {
            internalType: 'uint256',
            name: 'timestampsPerYear',
            type: 'uint256',
          },
          { internalType: 'address', name: 'token', type: 'address' },
          { internalType: 'address', name: 'underlying', type: 'address' },
          { internalType: 'string', name: 'symbol', type: 'string' },
          {
            internalType: 'string',
            name: 'underlyingSymbol',
            type: 'string',
          },
        ],
        internalType: 'struct MarketState.MarketsInfo[]',
        name: '',
        type: 'tuple[]',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
] as const
